import AuthSubjectForm from "@/components/AuthSubject/form";
import HBMessage from "@/components/HBMessage";
import HBModal from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import { getCertList, updateCert } from "@/services";
import { getAdaptiveImg } from "@/utils/imageUrl";
import { useCallback, useMemo, useState } from "react";
import { Case, Switch } from "react-if";
import PayResult from "../payResult";
import SubjectConfirm from "../subjectConfirm";
import styles from "./index.module.less";

const RawPaySuccessModal = ({ order, onOk, onCancel, ...props }) => {
  // 步骤
  const [step, setStep] = useState("payResult");
  const [vipType] = useState("personal");
  const [subject, setSubject] = useState({});

  const onSubmit = useCallback(async () => {
    const certSubject = await getCertList({
      source_no: order.order_no,
    });

    if (!certSubject?.list?.length > 0) {
      HBMessage.error("获取授权信息失败");
      return;
    }

    const result = await updateCert({
      id: certSubject.list[0].id,
      subject,
    });

    if (result.err) return;

    HBMessage.success("提交成功");
    onOk && onOk();
  }, [onOk, order, subject]);

  const next = useCallback(
    (params) => {
      if (step === "payResult") setStep("authSubject");
      if (step === "authSubject") {
        setSubject(params);
        setStep("subjectConfirm");
      }
    },
    [step]
  );

  const wrapStyle = useMemo(() => {
    return {
      width: 960,
      backgroundImage: `url(${getAdaptiveImg(
        "https://st0.dancf.com/static/02/202202110238-4e8a.jpg",
        { width: 960 }
      )})`,
      backgroundSize: "cover",
    };
  }, []);
  return (
    <HBModal
      width={960}
      footer={null}
      bodyStyle={{ padding: 0 }}
      onCancel={onCancel}
      {...props}
    >
      <div style={wrapStyle}>
        <Switch>
          <Case condition={step === "payResult"}>
            <div className={styles.resultWrap}>
              <PayResult onNext={next} order={order} data-source={"体验VIP"} />
            </div>
          </Case>
          <Case condition={step === "authSubject"}>
            <div className={styles.subjectWrap}>
              <h2>填写被授权方</h2>
              <AuthSubjectForm
                type={vipType}
                initValue={subject}
                scene="buyVip"
                onSubmit={next}
                onCancel={onCancel}
              />
            </div>
          </Case>
          <Case condition={step === "subjectConfirm"}>
            <div className={styles.subjectConfirmWrap}>
              <SubjectConfirm
                subject={subject}
                onBack={() => {
                  setStep("authSubject");
                }}
                onOk={onSubmit}
              />
            </div>
          </Case>
        </Switch>
      </div>
    </HBModal>
  );
};

const PaySuccessModal = ModalWrap(RawPaySuccessModal);

export default PaySuccessModal;
